export const defaultFontFaces = `
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('/fonts/Inter-Regular.woff2?v=3.19') format('woff2'),
    url('/fonts/Inter-Regular.woff?v=3.19') format('woff'),
    url('/fonts/Inter-Regular.otf?v=3.19') format('otf'),
    url('/fonts/Inter-Regular.ttf?v=3.19') format('ttf');
  }
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url('/fonts/Inter-Medium.woff2?v=3.19') format('woff2'),
      url('/fonts/Inter-Medium.woff?v=3.19') format('woff'),
      url('/fonts/Inter-Medium.otf?v=3.19') format('otf'),
      url('/fonts/Inter-Medium.ttf?v=3.19') format('ttf');
  }
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url('/fonts/Inter-SemiBold.woff2?v=3.19') format('woff2'),
      url('/fonts/Inter-SemiBold.woff?v=3.19') format('woff'),
      url('/fonts/Inter-SemiBold.otf?v=3.19') format('otf'),
      url('/fonts/Inter-SemiBold.ttf?v=3.19') format('ttf');
  }
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('/fonts/Inter-Bold.woff2?v=3.19') format('woff2'),
      url('/fonts/Inter-Bold.woff?v=3.19') format('woff'),
      url('/fonts/Inter-Bold.otf?v=3.19') format('otf'),
      url('/fonts/Inter-Bold.ttf?v=3.19') format('ttf');
  }`;

export const baseEditorStyles = `
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
  [dir='rtl'] {
    direction: rtl;
    unicode-bidi: embed;
  }
  [dir='rtl'] ul li,
  [dir='rtl'] ol li {
    text-align: right;
  }
  [dir='rtl'] ul,
  [dir='rtl'] ol,
  [dir='rtl'] ul ul,
  [dir='rtl'] ol ol,
  [dir='rtl'] ul ol,
  [dir='rtl'] ol ul {
    margin-left: 1.5em;
  }
  [dir='rtl'] figcaption {
    text-align: right;
  }
  ul[dir='rtl'],
  ul[dir='rtl'] ul,
  ul[dir='rtl'] ol,
  ol[dir='rtl'],
  ol[dir='rtl'] ul,
  ol[dir='rtl'] ol {
    margin-right: 1.5em;
  }
  ul[dir='rtl'] li,
  ol[dir='rtl'] li {
    text-align: right;
  }
  a {
    text-decoration: none;
    color: #074be2;
  }
  a:hover {
    text-decoration: none;
    color: #0532a3;
  }
  p,
  dl,
  blockquote,
  hr,
  pre,
  table,
  figure,
  address {
    padding: 0;
    margin: 0;
    margin-bottom: 1em;
  }
  ul,
  ol {
    padding: 0;
  }
  ul,
  ul ul,
  ul ol,
  ol,
  ol ul,
  ol ol {
    margin: 0 0 0 1.5em;
  }
  ul li,
  ol li {
    text-align: left;
  }
  ol ol li {
    list-style-type: lower-alpha;
  }
  ol ol ol li {
    list-style-type: lower-roman;
  }
  ul,
  ol {
    margin-bottom: 1em;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: bold;
    color: #1B1C1C;
    text-rendering: optimizeLegibility;
    margin: 0;
    padding: 0;
    margin-bottom: 0.5em;
    line-height: 1.2;
  }
  h1 {
    font-size: 2.0736em;
  }
  h2 {
    font-size: 1.728em;
  }
  h3 {
    font-size: 1.44em;
  }
  h4 {
    font-size: 1.2em;
  }
  h5 {
    font-size: 1em;
  }
  h6 {
    font-size: 0.83333em;
    text-transform: uppercase;
    letter-spacing: 0.035em;
  }
  blockquote {
    font-style: italic;
    color: rgba(0, 0, 0, 0.5);
    border: none;
  }
  table {
    width: 100%;
  }
  time,
  small,
  var,
  code,
  kbd,
  mark {
    display: inline-block;
    font-family: Consolas, Menlo, Monaco, 'Courier New', monospace;
    font-size: 87.5%;
    line-height: 1;
    color: rgba(51, 51, 51, 0.9);
  }
  var,
  cite {
    opacity: 0.6;
  }
  var {
    font-style: normal;
  }
  dfn,
  abbr {
    text-transform: uppercase;
  }
  dfn[title],
  abbr[title] {
    text-decoration: none;
    border-bottom: 1px dotted rgba(0, 0, 0, 0.5);
    cursor: help;
  }
  code,
  kbd {
    position: relative;
    top: -1px;
    padding: 0.25em;
    padding-bottom: 0.2em;
    border-radius: 2px;
  }
  code {
    background-color: #eff1f2;
  }
  mark {
    border-radius: 2px;
    padding: 0.125em 0.25em;
    background-color: #fdb833;
  }
  kbd {
    border: 1px solid #e5e7e9;
  }
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  pre {
    font-family: Consolas, Menlo, Monaco, 'Courier New', monospace;
    font-size: 0.9em;
  }
  pre,
  pre code {
    background-color: #f6f7f8;
    padding: 0;
    top: 0;
    display: block;
    line-height: 1.5;
    color: rgba(51, 51, 51, 0.85);
    overflow: none;
    white-space: pre-wrap;
  }
  pre {
    padding: 1rem;
  }
  table {
    border-collapse: collapse;
    max-width: 100%;
    width: 100%;
  }
  table caption {
    text-transform: uppercase;
    padding: 0;
    color: rgba(0, 0, 0, 0.5);
    font-size: 11px;
  }
  table th,
  table td {
    border: 1px solid #eee;
    padding: 16px;
    padding-bottom: 15px;
  }
  table tfoot th,
  table tfoot td {
    color: rgba(0, 0, 0, 0.5);
  }
  img,
  video,
  audio,
  embed,
  object {
    max-width: 100%;
  }
  img,
  video,
  embed,
  object {
    height: auto !important;
  }
  img {
    vertical-align: middle;
    -ms-interpolation-mode: bicubic;
  }
  figcaption {
    display: block;
    opacity: 0.6;
    font-size: 12px;
    font-style: italic;
    text-align: left;
  }
  p {
    margin-bottom: 0.2rem;
  }
  figure figcaption {
    text-align: inherit;
  }
  ul li,
  ol li {
    position: relative;
    left: 1em;
    width: calc(100% - 1em);
  }
  iframe {
    max-width: 100% !important;
  }
  figure.align-left {
    float: left;
  }
  figure.align-right {
    float: right;
  }
  figure.align-center {
    display: table;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const baseElementStyles = `
  font-family: Inter, sans-serif;
  font-size: 16px;
  color: #1B1C1C;
  box-sizing: border-box;
  line-height: 1.5;
`;
